import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faCog } from '@fortawesome/free-solid-svg-icons';

// Importar widgets específicos
import KPIWidget from './widgets/KPIWidget';
import ChartWidget from './widgets/ChartWidget';
import TableWidget from './widgets/TableWidget';

/**
 * Componente que renderiza el widget apropiado según su tipo
 */
const WidgetRenderer = ({ widget, editMode, onRemove, onConfigure }) => {
  const renderWidgetContent = () => {
    switch (widget.type) {
      case 'kpi-leads':
      case 'kpi-investment':
      case 'kpi-roi':
        return <KPIWidget widget={widget} />;
      
      case 'chart-investment-timeline':
      case 'chart-client-distribution':
        return <ChartWidget widget={widget} />;
      
      case 'table-recent-orders':
      case 'table-top-campaigns':
        return <TableWidget widget={widget} />;
      
      default:
        return (
          <div className="text-center text-muted py-4">
            <p>Widget: {widget.type}</p>
            <small>En desarrollo</small>
          </div>
        );
    }
  };

  return (
    <Card className="h-100 widget-container">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <span className="fw-bold">{widget.title}</span>
        {editMode && (
          <div>
            {onConfigure && (
              <Button 
                variant="link" 
                size="sm" 
                className="p-0 me-2"
                onClick={() => onConfigure(widget)}
              >
                <FontAwesomeIcon icon={faCog} />
              </Button>
            )}
            <Button 
              variant="link" 
              size="sm" 
              className="p-0 text-danger"
              onClick={() => onRemove(widget.id)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </div>
        )}
      </Card.Header>
      <Card.Body className="p-2">
        {renderWidgetContent()}
      </Card.Body>
    </Card>
  );
};

export default WidgetRenderer;




